import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';

const _logger = Log.create('Background-Service');
let _apiClient: ApiClient;

export class CalendarService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetCalendarDatasAsync(params: any) {
        const requestUrl = `api/calendar/getcalendardatas`;
        
        return _apiClient.RequestAsync('POST', requestUrl, params, '', false).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
}

